import Vue from 'vue';
import VueRouter from 'vue-router'
import Layout from '@/layout/index';
import AllWidthLayout from '@/layout/all-width-layout';
import BookLayout from '@/layout/book-layout';
import HomeLayout from '@/layout/home-layout';
import Login from '@/views/login';
import store from "@/store";
import {Message} from 'element-ui';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'IndexHome',
        component: () => import('@/views/ad/ad_data')
      }
    ],
    meta: {
      title: '广告数据',
      permission: 'ad_data:list'
    }
  },
  {
    path: '/home',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/home/index')
      }
    ]
  },
  {
    path: '/ad_data',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AdData',
        component: () => import('@/views/ad/ad_data.vue')
      }
    ],
    props: {
      menuIndex: 'ad-data'
    },
    meta: {
      title: '广告数据',
      permission: 'ad_data:list'
    }
  },
  {
    path: '/budget_report',
    component: Layout,
    children: [
      {
        path: '',
        name: 'BudgetReport',
        component: () => import('@/views/ad/budget_report.vue')
      }
    ],
    props: {
      menuIndex: 'budget-report'
    },
    meta: {
      title: '上报状态',
      permission: 'ad_data:list'
    }
  },
  {
    path: '/honor_supplement',
    component: Layout,
    children: [
      {
        path: '',
        name: 'HonorSupplement',
        component: () => import('@/views/ad/honor_supplement.vue')
      }
    ],
    props: {
      menuIndex: 'honor-supplement'
    },
    meta: {
      title: '荣耀补回传',
      permission: 'honor_supplement:list'
    }
  },
  {
    path: '/ad_channel',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AdChannel',
        component: () => import('@/views/ad/ad_channel.vue')
      }
    ],
    props: {
      menuIndex: 'ad-channel'
    },
    meta: {
      title: '渠道信息',
      permission: 'channel:list'
    }
  },
  {
    path: '/adv_media_list',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AdvMediaList',
        component: () => import('@/views/ad/adv_media_list.vue')
      }
    ],
    props: {
      menuIndex: 'adv-media-list'
    },
    meta: {
      title: '预算媒体管理',
      permission: 'adv_media:list'
    }
  },
  {
    path: '/adv_channel_up_down_list',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AdvChannelUpDownList',
        component: () => import('@/views/ad/adv_channel_up_down_list.vue')
      }
    ],
    props: {
      menuIndex: 'adv-channel-up-down-list'
    },
    meta: {
      title: '渠道上下游',
      permission: 'up_down_info:list'
    }
  },
  {
    path: '/adv_channel_action_list',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AdvChannelActionList',
        component: () => import('@/views/ad/adv_channel_action_list.vue')
      }
    ],
    props: {
      menuIndex: 'adv-channel-action-list'
    },
    meta: {
      title: '转化配置',
      permission: 'up_down_action:list'
    }
  },
  {
    path: '/adv_budget_link_list',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AdvBudgetLinkList',
        component: () => import('@/views/ad/adv_budget_link_list.vue')
      }
    ],
    props: {
      menuIndex: 'adv-budget-link-list'
    },
    meta: {
      title: '预算链接',
      permission: 'adv_link:list'
    }
  },
  {
    path: '/adv_media_link_list',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AdvMediaLinkList',
        component: () => import('@/views/ad/adv_media_link_list.vue')
      }
    ],
    props: {
      menuIndex: 'adv-media-link-list'
    },
    meta: {
      title: '媒体链接',
      permission: 'media_link:list'
    }
  },
  {
    path: '/adv_media_link_debug/:id',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AdvMediaLinkDebug',
        component: () => import('@/views/ad/adv_media_link_debug.vue'),
        props: true
      }
    ],
    props: {
      menuIndex: 'adv-media-link-list'
    },
    meta: {
      title: '媒体链接',
      permission: 'media_link:list'
    }
  },
  {
    path: '/media_flow_allocate_list',
    component: Layout,
    children: [
      {
        path: '',
        name: 'MediaFlowAllocateList',
        component: () => import('@/views/ad/media_flow_allocate_list.vue')
      }
    ],
    props: {
      menuIndex: 'media-flow-allocate-list'
    },
    meta: {
      title: '流量分配',
      permission: 'flow:list'
    }
  },
  {
    path: '/app_show_data_supply_list',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AppShowDataSupplyList',
        component: () => import('@/views/ad/app_show_data_supply_list.vue')
      }
    ],
    props: {
      menuIndex: 'app-show-data-supply-list'
    },
    meta: {
      title: '曝光补充',
      permission: 'app_show:list'
    }
  },
  {
    path: '/user_permission',
    component: Layout,
    children: [
      {
        path: '',
        name: 'UserPermission',
        component: () => import('@/views/ad/user_permission.vue')
      }
    ],
    props: {
      menuIndex: 'user-permission'
    },
    meta: {
      title: '用户权限',
      permission: 'user:list'
    }
  },
  {
    path: '/ad_link',
    component: Layout,
    children: [
      {
        path: '',
        name: 'LinkWrapper',
        component: () => import('@/views/ad/link_wrapper.vue'),
        children: [
          {
            path: 'list',
            name: 'AdLink',
            component: () => import('@/views/ad/link/ad_link.vue')
          },
          {
            path: ':linkId',
            name: 'LinkDetail',
            component: () => import('@/views/ad/link/link_detail.vue'),
            props: (route) => ({
              linkId: Number(route.params.linkId)  // 在这里转换类型
            })
          }
        ],
      }
    ],
    props: {
      menuIndex: 'ad-link'
    },
    meta: {
      title: '链接',
      permission: 'adv_link:list'
    }
  },
  // {
  //   path: '/link_detail/:linkId',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       name: 'LinkDetailWrapper',
  //       component: () => import('@/views/ad/link_wrapper.vue'),
  //       children: [{
  //         path: '',
  //         name: 'LinkDetail',
  //         component: () => import('@/views/ad/link/ad_link.vue'),
  //         props: (route) => ({
  //           linkId: Number(route.params.linkId)  // 在这里转换类型
  //         }),
  //       }],
  //       meta: {
  //         keepAlive: false,  // 详情页不需要缓存
  //       }
  //     }
  //   ],
  //   props: {
  //     menuIndex: 'ad-link'
  //   }
  // },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/tool',
  //   children: [
  //     {
  //       path: 'tool',
  //       name: 'Tool',
  //       components: {
  //         default: () => import('@/views/tool/tool'),
  //         footer: () => import('@/components/brief-footer-page')
  //       }
  //     }
  //   ]
  // },
  {
    path: '/qa-info-audit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'QaInfoAudit',
        component: () => import('@/views/audit/qa-info-audit')
      }
    ]
  },
  {
    path: '/qa-answer-audit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'QaAnswerAudit',
        component: () => import('@/views/audit/qa-answer-audit')
      }
    ]
  },
  {
    path: '/qa-tab-audit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'QaTabAudit',
        component: () => import('@/views/audit/qa-tab-audit')
      }
    ]
  },
  {
    path: '/qa-tool-audit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'QaToolAudit',
        component: () => import('@/views/audit/qa-tool-audit')
      }
    ]
  },
  {
    path: '/tool-audit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'ToolAudit',
        component: () => import('@/views/audit/tool-audit')
      }
    ]
  },
  {
    path: '/name-manage',
    component: Layout,
    children: [
      {
        path: '',
        name: 'NameManage',
        component: () => import('@/views/audit/name-manage')
      }
    ]
  },
  {
    path: '/modify-data-audit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'ModifyDataAudit',
        component: () => import('@/views/audit/modify-data-audit')
      }
    ]
  },
  {
    path: '/user-audit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'UserAudit',
        component: () => import('@/views/audit/user-audit')
      }
    ]
  },
  {
    path: '/tool-edit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'ToolEdit',
        component: () => import('@/views/audit/tool-edit')
      }
    ]
  },
  {
    path: '/article-audit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'ArticleAudit',
        component: () => import('@/views/article/article-audit')
      }
    ]
  },
  {
    path: '/article-edit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'ArticleEdit',
        component: () => import('@/views/article/article-edit')
      }
    ]
  },
  {
    path: '/tool-category-audit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'ToolCategoryAudit',
        component: () => import('@/views/audit/tool-category-audit')
      }
    ]
  },
  {
    path: '/tool-category-edit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'ToolCategoryEdit',
        component: () => import('@/views/audit/tool-category-edit')
      }
    ]
  },
  {
    path: '/issue-audit',
    component: Layout,
    children: [
      {
        path: '',
        name: 'IssueAudit',
        component: () => import('@/views/issue/issue')
      }
    ]
  },
  {
    path: '/about',
    component: Layout,
    children: [
      {
        path: '',
        name: 'About',
        component: () => import('@/views/others/about')
      }
    ]
  },
  {
    path: '/advertisement',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Advertisement',
        component: () => import('@/views/others/advertisement')
      }
    ]
  },
  {
    path: '/join-us',
    component: Layout,
    children: [
      {
        path: '',
        name: 'JoinUs',
        component: () => import('@/views/others/join-us')
      }
    ]
  },
  {
    path: '/feedback',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Feedback',
        component: () => import('@/views/others/feedback')
      }
    ]
  },
  {
    path: '/add-project',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AddProject',
        component: () => import('@/views/project/add-project')
      }
    ]
  },
  {
    path: '/project/:projectId',
    component: Layout,
    children: [
      {
        path: ':tab',
        name: 'Project',
        props: true,
        component: () => import('@/views/project/project')
      }
    ]
  },
  {
    path: '/add-iteration',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AddIteration',
        component: () => import('@/views/iteration/add-iteration')
      }
    ]
  },
  {
    path: '/add-source',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AddSource',
        component: () => import('@/views/source/add-source')
      }
    ]
  },
  {
    path: '/source/:sourceId',
    component: AllWidthLayout,
    children: [
      {
        path: '',
        name: 'Source',
        props: true,
        component: () => import('@/views/source/api-source')
      }
    ]
  },
  {
    path: '/add-doc',
    component: Layout,
    children: [
      {
        path: '',
        name: 'AddDocumentation',
        component: () => import('@/views/documentation/add-documentation')
      }
    ]
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/sign-up',
    component: Layout,
    children: [{
      path: '',
      name: 'SignUp',
      component: () => import('@/views/SignUp')
    }]
  },
  {
    path: '/book',
    component: BookLayout,
    children: [{
      path: '',
      name: 'Book',
      props: (route) => ({id: route.query.bookId}),
      component: () => import('@/views/book/Book')
    }]
  },
  {
    path: '/book/add',
    component: HomeLayout,
    children: [{
      path: '',
      name: 'AddBook',
      components: {
        default: () => import('@/views/book/add-book'),
        footer: () => import('@/components/brief-footer-page')
      }
    }]
  },
  {
    path: '/book/hub',
    component: Layout,
    props: true,
    children: [{
      path: ':bookId',
      name: 'BookHub',
      props: true,
      component: () => import('@/views/book/BookHub')
    }]
  },
  {
    path: '/book/screen',
    component: Layout,
    props: true,
    children: [{
      path: ':content',
      name: 'BookScreen',
      props: true,
      component: () => import('@/views/book/BookScreen')
    }]
  },
  {
    path: '/qa',
    component: Layout,
    children: [
      {
        path: '',
        name: 'QuestionAnswer',
        component: () => import('@/views/question-answer/index')
      },
      {
        path: 'ask',
        name: 'AskQuestion',
        component: () => import('@/views/question-answer/AskQuestion')
      },
      {
        path: 'answer',
        name: 'Answer',
        component: () => import('@/views/question-answer/Answer')
      },
      {
        path: 'question/:questionId',
        name: 'Question',
        props: true,
        component: () => import('@/views/question-answer/Question')
      }
    ]
  },
  {
    path: '/point',
    component: Layout,
    children: [{
      path: '',
      name: 'Point',
      component: () => import('@/views/point/index')
    }]
  },
  {
    path: '/community',
    component: Layout,
    children: [{
      path: '',
      name: 'Community',
      component: () => import('@/views/community/index')
    }]
  },
  {
    path: '/article',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Article',
        component: () => import('@/views/article/index')
      },
      {
        path: 'add',
        name: 'AddArticle',
        component: () => import('@/views/article/AddArticle')
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    children: [
      {
        path: ':userId',
        name: 'User',
        props: true,
        component: () => import('@/views/user/index'),
        children: [
          {
            path: 'account',
            name: 'UserAccount',
            component: () => import('@/views/user/info-component/account')
          },
          {
            path: 'contribution',
            name: 'UserContribution',
            component: () => import('@/views/user/info-component/contribution')
          },
          {
            path: 'favorite',
            name: 'UserFavorite',
            component: () => import('@/views/user/info-component/favorite')
          },
          {
            path: 'follow',
            name: 'UserFollow',
            component: () => import('@/views/user/info-component/follow')
          },
          {
            path: 'history',
            name: 'UserHistory',
            component: () => import('@/views/user/info-component/history')
          },
          {
            path: 'honor',
            name: 'UserHonor',
            component: () => import('@/views/user/info-component/honor')
          }, {
            path: 'income',
            name: 'UserIncome',
            component: () => import('@/views/user/info-component/income')
          },
          {
            path: 'security',
            name: 'UserSecurity',
            component: () => import('@/views/user/info-component/security')
          },
          {
            path: 'setting',
            name: 'UserSetting',
            component: () => import('@/views/user/info-component/setting')
          },
          {
            path: 'book',
            name: 'UserBook',
            component: () => import('@/views/user/info-component/book')
          }
        ]
      }
    ]
  }
]

/**
 * 禁止全局路由错误处理打印
 * @param location
 * @param onResolve
 * @param onReject
 * @returns {Promise<Route>|void|Promise<Route>}
 */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
const createRouter = () => new VueRouter({
  mode: "history",
  // base: '/admin',
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})
const router = createRouter()

router.beforeEach((async (to, from, next) => {
  document.title = '管理平台'
  // 登录页直接放行
  if (to.path === '/login') {
    next();
    return;
  }
  // 未登录时跳转到登录页
  if (!store.getters.token) {
    router.replace({
      path: '/login'
    }).then();
    return;
  }
  // 已登录但还没拉取权限信息（首次进入或刷新页面），先拉取再放行
  if (!store.getters.permissionsLoaded) {
    try {
      await store.dispatch('user/getInfo');
    } catch (e) {
      store.dispatch('user/resetToken');
      router.replace({
        path: '/login'
      }).then();
      return;
    }
  }
  // 页面级权限校验
  const permission = to.meta && to.meta.permission;
  if (permission && !store.getters.hasPerm(permission)) {
    Message.error('无权限访问该页面');
    next(false);
    return;
  }
  next();
}))

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
